import React from "react";
import {
  DropdownAction,
  DefaultColumnBuilder as builder,
} from "../../components/ColumnBuilder";
import { Sdk } from "../../../types/sdk";
import { Table, TablePaginationConfig } from "antd";

export interface SdkListProps {
  loading: boolean;
  records: Sdk[];
  editable?: boolean;
  actions?: DropdownAction[];
  pagination?: TablePaginationConfig | false;
  onChange?: (pagination: TablePaginationConfig) => void;
  selectRecods?: (ids: number[]) => void;
  viewRecord?: (id: number) => void;
  editRecord?: (id: number) => void;
  copyRecord?: (id: number) => void;
  removeRecord?: (id: number) => void;
  visibleColumns?: string[];
}

export const getSdkColumns = (
  editable?: boolean,
  actions?: DropdownAction[],
  callbacks?: {
    viewRecord?: (id: number) => void;
    editRecord?: (id: number) => void;
    copyRecord?: (id: number) => void;
    removeRecord?: (id: number) => void;
  }
) => {
  let columns = [
    builder.id,
    builder.platform("platform"),
    builder.text("Status", "status", true),
    builder.text("Display Name", "name"),
    builder.version,
    builder.requirement("Requirement", "requirement"),
    builder.category("category"),
    builder.boolean("Reindex", "reindexEnabled"),
    builder.date("Created At", "createdAt"),
  ];

  if (editable) {
    const action = builder.dropdown(
      actions || [
        DropdownAction.VIEW,
        DropdownAction.EDIT,
        DropdownAction.COPY,
        DropdownAction.DELETE,
      ],
      (id, action) => {
        console.log(id, action);
        switch (action) {
          case DropdownAction.VIEW:
            return callbacks?.viewRecord?.(id);
          case DropdownAction.EDIT:
            return callbacks?.editRecord?.(id);
          case DropdownAction.COPY:
            return callbacks?.copyRecord?.(id);
          case DropdownAction.DELETE:
            return callbacks?.removeRecord?.(id);
        }
      }
    );
    columns.push(action);
  }

  return columns;
};

export const SdkList = (props: SdkListProps) => {
  const columns = () => {
    let columns = getSdkColumns(props.editable, props.actions, {
      viewRecord: props.viewRecord,
      editRecord: props.editRecord,
      copyRecord: props.copyRecord,
      removeRecord: props.removeRecord,
    });

    // Filter by visible columns (always show action column with fixed="right")
    if (props.visibleColumns && props.visibleColumns.length > 0) {
      columns = columns.filter(
        (c) => c.fixed === "right" || props.visibleColumns!.includes(c.dataIndex?.toString() || "")
      );
    }

    return columns;
  };

  const rowSelection = {
    onChange: (_: React.Key[], selectedRows: any[]) => {
      props.selectRecods?.(selectedRows.map((row) => row.key));
    },
  };

  return (
    <Table
      loading={props.loading}
      columns={columns()}
      pagination={props.pagination}
      onChange={props.onChange}
      dataSource={(props.records || []).map((record) => ({
        ...record,
        key: record.id,
      }))}
      onRow={(record) => ({
        onClick: () => {
          if (record.id !== undefined) props.viewRecord?.(record.id);
        },
      })}
      rowSelection={props.selectRecods && rowSelection}
    />
  );
};
